/* eslint-disable no-shadow, no-param-reassign */
const getDefaultState = () => {
	return {
		activeForm: 1,
		selectedLoanOfficer: '',
		loanOfficerOptions: [],

		// pricing values
		brokerId: null,
		brokerNMLS: null,
		loanAmountString: null,
		salesPriceString: null,
		ltvString: '0',
		selectedMortgageInsuranceType: null,
		selectedLoanType: [],
		selectedAmortizationType: null,
		selectedVAUseType: null,
		selectedServiceType: null,
		selectedLoanPurpose: null,
		selectedRefinancePurpose: null,
		selectedCashOutPurpose: null,
		selectedOccupancy: null,
		propertiesFinanced: '1',
		selectedPropertyType: null,
		numberOfUnits: '1',
		propertyZip: null,
		propertyCounty: null,
		propertyState: null,
		creditScore: null,
		selectedCommitmentPeriod: null,
		selectedCompensationType: null,
		selectedDocumentationType: null,
		selectedEscrowImpoundType: null,
		selectedLoanTerm: [],
		selectedFirstTimeHomebuyer: null,
		loanAmountNum: null,
		salesPriceNum: null,
		ltvNum: null,
		// advanced options
		monthlyIncome: null,
		monthlyDebt: null,
		annualTaxes: null,
		annualHoi: null,
		aprFees: null,
		county: null,
		state: null,

		// TODO: remove once Lendwize is returning again
		productData: [],
		ineligibleData: [],
		flyerImages: [null, null, null],
		flyerData: [
			{
				productName: 'Scenario 1',
				selected: false,
				downPayment: 0,
				mi: 0,
				interest: 0,
				apr: 0,
				estTaxInsurance: '0.00 / 0.00',
				payment: 0,
			},
			{
				productName: 'Scenario 2',
				selected: false,
				downPayment: 0,
				mi: 0,
				interest: 0,
				apr: 0,
				estTaxInsurance: '0.00 / 0.00',
				payment: 0,
			},
			{
				productName: 'Scenario 3',
				selected: false,
				downPayment: 0,
				mi: 0,
				interest: 0,
				apr: 0,
				estTaxInsurance: '0.00 / 0.00',
				payment: 0,
			},
		],
		flyerDisclaimer: '',
		fhaDisclaimer: null,
	};
};

const state = getDefaultState();

const mutations = {
	SET_DISCLAIMER(state, payload) {
		state.flyerDisclaimer = payload;
	},

	UPDATE_PRICING_FIELDS(state, payload) {
		state[payload.fieldName] = payload.value;
	},

	ADJUST_OPTIONS_LIMIT_STATE(state, payload) {
		const currentOptionsLimit = state.productData[payload].optionsDisplayLimit;

		if (currentOptionsLimit === 3) {
			state.productData[payload].optionsDisplayLimit = 999;
		} else {
			state.productData[payload].optionsDisplayLimit = 3;
		}
	},

	UPDATE_FLYER_IMAGE(state, payload) {
		state.flyerImages.splice(payload.index, 1, payload.url);
	},

	DELETE_FLYER_IMAGE(state, payload) {
		state.flyerImages.splice(payload.index, 1, null);
	},

	TOGGLE_PRODUCT(state, payload) {
		const currentState =
			state.productData[payload.catIndex].products[payload.prodIndex].selected;

		state.productData[payload.catIndex].products[payload.prodIndex].selected =
			!currentState;
	},

	TOGGLE_ELIGIBLE(state, payload) {
		const currentState = state.productData[payload.catIndex].show;

		state.productData[payload.catIndex].show = !currentState;
	},

	TOGGLE_INELIGIBLE(state, payload) {
		const currentState = state.ineligibleData[payload.index].show;

		state.ineligibleData[payload.index].show = !currentState;
	},

	UPDATE_FLYER_DATA(state) {
		let selectedProducts = [...state.productData.map((e) => e.products)]
			.flat()
			.filter((e) => e.selected);
		let index = 0;

		function prepVar(value) {
			if (isNaN(value) || value === null || value < 0) {
				return 0;
			}

			return value;
		}

		state.flyerData = [
			{
				estTaxInsurance: '0.00 / 0.00',
				selected: false,
			},
			{
				estTaxInsurance: '0.00 / 0.00',
				selected: false,
			},
			{
				estTaxInsurance: '0.00 / 0.00',
				selected: false,
			},
		];

		if (selectedProducts.length > 0) {
			for (let product of selectedProducts) {
				const downpayment = prepVar(state.salesPriceNum - state.loanAmountNum);
				const downpaymentPercentage = Math.abs(
					((state.loanAmountNum / state.salesPriceNum) * 100 - 100).toFixed(2),
				);
				const mi = prepVar(product.mortgageInsuranceAnnualDollar);
				const apr = prepVar(product.annualPercentageRate);
				const taxes = prepVar(product.taxes);
				const insurance = prepVar(product.insurance);
				const monthlyPayment =
					parseFloat(product.monthlyPayment) +
					parseFloat(taxes) +
					parseFloat(insurance);
				const financeCharges = product.financeCharges;

				const data = {
					productName: product.productName,
					selected: true,
					downPayment: `${downpayment} / ${downpaymentPercentage}%`,
					mi: parseFloat(mi).toFixed(2),
					interest: product.interest,
					apr: parseFloat(apr).toFixed(2),
					estTaxInsurance: `${parseFloat(taxes).toFixed(2)} / ${parseFloat(
						insurance,
					).toFixed(2)}`,
					payment: parseFloat(monthlyPayment).toFixed(2),
					financeCharges: parseFloat(financeCharges).toFixed(2),
				};

				state.flyerData.splice(index, 1, data);
				index++;
			}
		}
	},

	UPDATE_FHA_DISCLAIMER_TEXT(state, payload) {
		state.fhaDisclaimer = payload;
	},

	UPDATE_COUNTY(state, payload) {
		state.propertyCounty = payload;
	},

	UPDATE_STATE(state, payload) {
		state.propertyState = payload;
	},

	UPDATE_BROKER_ID(state, payload) {
		state.brokerId = payload;
	},

	UPDATE_BROKER_NMLS(state, payload) {
		state.brokerNMLS = payload;
	},
	RESET_PRICING_FLYER(state) {
		Object.assign(state, getDefaultState());
	},
};

const actions = {
	updatePricingFields(context, data) {
		context.commit('UPDATE_PRICING_FIELDS', data);
	},

	adjustOptionsLimitState(context, data) {
		context.commit('ADJUST_OPTIONS_LIMIT_STATE', data);
	},

	updateFlyerImage(context, data) {
		context.commit('UPDATE_FLYER_IMAGE', data);
	},

	deleteFlyerImage(context, data) {
		context.commit('DELETE_FLYER_IMAGE', data);
	},

	toggleProduct(context, data) {
		context.commit('TOGGLE_PRODUCT', data);
	},

	toggleEligible(context, data) {
		context.commit('TOGGLE_ELIGIBLE', data);
	},

	toggleIneligible(context, data) {
		context.commit('TOGGLE_INELIGIBLE', data);
	},

	updateFlyerData(context, data) {
		context.commit('UPDATE_FLYER_DATA');
	},

	resetPricingFlyerData(context) {
		context.commit('RESET_PRICING_FLYER');
	},

	updateFHADisclaimerText(context, disclaimerText) {
		context.commit('UPDATE_FHA_DISCLAIMER_TEXT', disclaimerText);
	},

	updateLocation(context, data) {
		context.commit('UPDATE_COUNTY', data.county);
		context.commit('UPDATE_STATE', data.state);
	},
	updateBrokerInfo(context, data) {
		context.commit('UPDATE_BROKER_ID', data.brokerId);
		context.commit('UPDATE_BROKER_NMLS', data.brokerNMLS);
	},
};

export default {
	state,
	mutations,
	actions,
};
